"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var angular_1 = __importDefault(require("angular"));
var siteUrl = process.env.SITE_URL;
exports.Config = angular_1.default.module("constants.config", [])
    .constant("APPURL", process.env.APP_URL)
    .constant("ENV", process.env.APP_ENV)
    .constant("HTML_FIVE_MODE", process.env.HTML_FIVE_MODE || 'off')
    .constant("SITEURL", siteUrl)
    .constant("HTML_FIVE_MODE", process.env.HTML_FIVE_MODE || 'off')
    .constant("OPENREPLAY_PROJECT_KEY", process.env.OPENREPLAY_PROJECT_KEY || null)
    .constant("OPENREPLAY_INGEST_POINT", process.env.OPENREPLAY_INGEST_POINT || null)
    .constant("PUSHER_KEY", process.env.PUSHER_KEY);
